import { FC } from "react";
import { Icon, Button } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { useModal, useWatchState } from "@/store";

import img1_1 from './images/1-1.png';
import img1_2 from './images/1-2.png';
import img1_3 from './images/1-3.png';
import img1_4 from './images/1-4.png';
import img1_5 from './images/1-5.png';
import img1_6 from './images/1-6.png';
import img1_7 from './images/1-7.png';
import img1_8 from './images/1-8.png';
import img2_1 from './images/2-1.png';
import img2_2 from './images/2-2.png';
import img2_3 from './images/2-3.png';
import img2_4 from './images/2-4.png';
import img2_5 from './images/2-5.png';
import img2_6 from './images/2-6.png';
import img2_7 from './images/2-7.png';
import img2_8 from './images/2-8.png';
import offlinePng from './images/offline.png';
import coverPng from './images/cover.png';

import "./index.less";

const configs = [
  // 成果发布过滤筛选 0
  { 
      title: '成果发布过滤筛选',
      cover: img1_1,
      rightCover: true,
      guide: [
          '注册用户登录云工坊', 
          '自主发布用户好成果', 
          '天合对成果过滤筛选', 
          '一级好成果分类促进', 
          '二级成果上云网推介',
      ],
      phones: [
          '业务支持：祁先生',
          '联系电话：18618293420',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 数字画像智能匹配 1
  { 
      title: '数字画像智能匹配',
      cover: img1_2, 
      rightCover: true,
      guide: [
          '天合为好成果数字画像',
          '为好成果智能匹配需求',
          '用户菜单订阅查询需求',
          '智能匹配结果实时推送',
          '用户可移动客户端操作',
      ],
      phones: [
          '业务支持：祁先生',
          '联系电话：18618293420',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 企业需求定向推送 2
  { 
      title: '企业需求定向推送',
      cover: img1_3, 
      x: 125,
      rightCover: true,
      offline: true,
      guide: [
          '天合多渠道筛选好需求',
          '天合为您定制定向推送',
          '云工坊按用户菜单推送',
          '两聚三精需求线下推送',
          '好需求推洽会现场推送',
          '产业共性技术平台邀请',
      ],
      phones: [
          '业务支持：祁先生',
          '联系电话：18618293420',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]  
  },
  // 精准对接意向撮合 3
  { 
      title: '精准对接意向撮合',
      cover: img1_4, 
      offline: true,
      x: 110,
      guide: [
          '云工坊自动化智能匹配',
          '企业需求定向联络撮合',
          '优秀成果精准定向推介',
          '成果需求合作意向促进',
          '供需双方签订意向协议',
          '天合平台立项促进服务',
      ],
      phones: [
          '业务支持：祁先生',
          '联系电话：18618293420',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 成果转化要素评价 4
  { 
      title: '成果转化要素评价',
      cover: img1_5, 
      rightCover: true,
      offline: true,
      x: 130,
      guide: [
          '客户委托天合专业评价',
          '地区招商引资项目评价',
          '金融资本投资项目评价',
          '科研机构转化项目评价',
          '政府扶持科技项目评价',
          '企业产品市场推广评价',
      ],
      phones: [
          '业务支持：辛女士',
          '联系电话：15810320771',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 成果估值挂牌交易 5
  { 
      title: '成果估值挂牌交易',
      cover: img1_6, 
      rightCover: true,
      guide: [
          '客户委托天合交易服务',
          '成果上《云市场》挂牌',
          '天合为成果做市场估值',
          '天合为揭牌方撮合促进',
          '天合参与意向项目合作',
          '天合配置资源资本助推',
      ],
      phones: [
          '业务支持：祁先生',
          '联系电话：18618293420',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 申请参与转化项目 6
  { 
      title: '申请参与转化项目',
      cover: img1_7, 
      offline: true,
      x: 114,
      guide: [
          '科研机构会员合同委托',
          '中小企业科技攻关项目',
          '骨干企业重大创新项目',
          '专精特新企业赋能项目',
          '产业园区招商路演项目',
          '地区产业协创平台项目',
          '上市公司科创升级项目',
      ],
      phones: [
          '业务支持：祁先生',
          '联系电话：18618293420',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 研发项目合作需求 7
  { 
      title: '研发项目合作需求',
      cover: img1_8, 
      rightCover: true,
      guide: [
          '用户登录《转化项目云市场》',
          '用户点击《合作需求挂牌榜》',
          '天合云平台线下服务中心受理',
          '用户签署项目挂牌交易委托书',
          '用户提交挂牌项目的相关资料',
          '用户安排联系人响应合作信息',
      ],
      phones: [
          '业务支持：祁先生',
          '联系电话：18618293420',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 需求发布精深解析 8
  { 
      title: '需求发布精深解析',
      cover: img2_1, 
      rightCover: true,
      guide: [
          '注册用户登录云工坊',
          '自主发布用户好需求',
          '天合对需求过滤筛选',
          '一级好需求分类促进',
          '二级需求上云网推介',
      ],
      phones: [
          '业务支持：肖女士',
          '联系电话：18131459757',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 数字画像智能匹配 9
  { 
      title: '数字画像智能匹配',
      cover: img2_2, 
      rightCover: true,
      guide: [
          '天合为好需求数字画像',
          '为好需求智能匹配成果',
          '用户菜单订阅查询成果',
          '智能匹配结果实时推送',
          '用户可移动客户端操作',
      ],
      phones: [
          '业务支持：杨女士',
          '联系电话：18701397959',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 科技成果定向推送 10
  { 
      title: '科技成果定向推送',
      cover: img2_3, 
      rightCover: true,
      offline: true,
      x: 125,
      guide: [
          '天合多渠道筛选好成果',
          '天合为您定制定向推送',
          '云工坊按用户菜单推送',
          '定向挖掘成果线下推送',
          '好成果推介会现场推送',
          '产业共性技术平台邀请',
      ],
      phones: [
          '业务支持：肖女士',
          '联系电话：18131459757',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 精准对接意向撮合 11
  { 
      title: '精准对接意向撮合',
      cover: img2_4, 
      offline: true,
      x: 110,
      guide: [
          '云工坊自动化智能匹配',
          '企业需求定向联络撮合',
          '优秀成果精准定向推介',
          '成果需求合作意向促进',
          '供需双方签订意向协议',
          '天合平台立项促进服务',
      ],
      phones: [
          '业务支持：祁先生',
          '联系电话：18618293420',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 企业创新能力评价 12
  { 
      title: '企业创新能力评价',
      cover: img2_5, 
      rightCover: true,
      offline: true,
      x: 131,
      guide: [
          '客户委托天合专业评价',
          '中小企业创新能力体检',
          '专精特新升级能力评估',
          '资本投资项目企业评价',
          '传统企业转型方案评价',
          '产业项目参与企业评价',
      ],
      phones: [
          '业务支持：辛女士',
          '联系电话：15810320771',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 企业需求揭榜挂帅 13
  { 
      title: '企业需求揭榜挂帅',
      cover: img2_6, 
      rightCover: true,
      guide: [
          '客户委托天合项目促进',
          '需求上《云市场》挂牌',
          '天合帮企业策划好项目',
          '天合为好项目融资推介',
          '天合参与意向项目合作',
          '天合配置资源资本助推',
      ],
      phones: [
          '业务支持：肖女士',
          '联系电话：18131459757',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 委托助推转化项目 14
  { 
      title: '委托助推转化项目',
      cover: img2_7, 
      offline: true,
      x: 124,
      guide: [
          '科创企业会员合同委托',
          '中小企业科技攻关项目',
          '骨干企业重大创新项目',
          '专精特新企业赋能项目',
          '产业园区招商路演项目',
          '地区产业协创平台项目',
          '上市公司科创升级项目',
      ],
      phones: [
          '业务支持：肖女士',
          '联系电话：18131459757',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
  // 科创产品升级推广 15
  { 
      title: '科创产品升级推广',
      cover: img2_8, 
      offline: true,
      x: 115,
      guide: [
          '用户登录《转化项目云市场》',
          '用户点击《科技成果挂牌榜》',
          '天合云平台线下服务中心受理',
          '用户签署项目挂牌交易委托书',
          '用户提交挂牌项目的相关资料',
          '用户安排联系人响应合作信息',
      ],
      phones: [
          '业务支持：肖女士',
          '联系电话：18131459757',
          '云网合作：周女士',
          '联系电话：13811374322',
      ]
  },
]

interface MemberFunctionInfoProps {
  type: number
  isLogin?: boolean
  showBtn?: boolean
  onClose?: () => void
}

const MemberFunctionInfo: FC<MemberFunctionInfoProps> = function MemberFunctionInfo({ type, isLogin, showBtn = true, onClose }) {

  const config = configs[type]
  const [[{ IS_LOGIN, info }]] = useWatchState([ "user" ]);

  return (
    <div className="com-member_function_info">
      <h2 className="com-member_function_info_title">{config.title}</h2>
      <div className="flex">
        <div className="com-member_function_info_contentLeft">
            <div className="com-member_function_info_contentLeft_cover" style={{ backgroundImage: `url(${config.cover})`, ...((IS_LOGIN || !config.rightCover) ? {} : { width: '674px', height: '380px' }) }}>
          </div>
          
        </div>
        <div className="com-member_function_info_contentRight">
          <div className="com-member_function_info_card">
            <div className="com-member_function_info_cardTitle">天合服务指南</div>
            <div className="com-member_function_info_cardContent">
              {config.guide.map(text => <p>{text}</p>)}
              {config.rightCover && !IS_LOGIN && <img src={coverPng} alt="" />}
            </div>
          </div>
          {IS_LOGIN && <div className="com-member_function_info_card">
            {config.offline && IS_LOGIN && <img className="offline-img" style={{ transform: `translate(-${config.x || 104}%, 54px)` }} src={offlinePng} alt="" />}
            <div className="com-member_function_info_cardTitle">联系方式</div>
            <div className="com-member_function_info_cardContent">
              <div className="ver">
                {config.phones.map(text => <p className="w-full">{text}</p>)}
              </div>
            </div>
          </div>}
        </div>
      </div>
      <div className="flex hor" style={{ width: '65vmin' }}>
        {showBtn && <Button className="mt-30" type="primary" onClick={onClose} style={{ width: 300 }}>我已了解</Button>}
      </div>
    </div>
  );
};
export default MemberFunctionInfo;
